import { memo, ReactElement } from 'react';
import PropTypes from 'prop-types';
import Queue from '@material-ui/icons/Queue';
import { Link } from 'react-router-dom';
import { stringify } from 'query-string';
import { Record, useResourceContext } from 'ra-core';
import { Button, ButtonProps } from 'react-admin';

const omitDefault = ({ id, status, ...rest }: Record) => rest;

export const GCloneButton = (props: GCloneButtonProps) => {
    const {
        basePath = '',
        label = 'ra.action.clone',
        scrollToTop = true,
        record,
        size = "medium",
        variant = "contained",
        icon = defaultIcon,
        omit = omitDefault,
        ...rest
    } = props;
    const resource = useResourceContext();
    const pathname = basePath ? `${basePath}/create` : `/${resource}/create`;
    return (
        <Button
            size={size}
            variant={variant}
            component={Link}
            to={
                record
                    ? {
                        pathname,
                        search: stringify({
                            source: JSON.stringify(omit(record)),
                        }),
                        state: { _scrollToTop: scrollToTop },
                    }
                    : pathname
            }
            label={label}
            onClick={stopPropagation}
            {...rest}
        >
            {icon}
        </Button>
    );
};

const defaultIcon = <Queue />;

// useful to prevent click bubbling in a datagrid with rowClick
const stopPropagation = e => e.stopPropagation();

interface Props {
    basePath?: string;
    record?: Record;
    icon?: ReactElement;
    scrollToTop?: boolean;
    omit?: Function;
}

export type GCloneButtonProps = Props & ButtonProps;

GCloneButton.propTypes = {
    basePath: PropTypes.string,
    icon: PropTypes.element,
    label: PropTypes.string,
    record: PropTypes.any,
};

export default memo(GCloneButton);